module.exports = __webpack_public_path__ + "img/logo-new.a2cef632.png";